jQuery(document).ready(function($) {
  new MenuSeparators('.footer .links .link', .8, '|')
})